import React from 'react';
import { FormattedMessage } from 'react-intl';

// List of all integrations

const INTEGRATIONS_MAP = {
  acronis: 'ACRONIS',
  bitDefender: 'BITDEFENDER',
  teamViewer: 'TEAM_VIEWER',
  superopsSplashTop: 'SUPEROPS_SPLASH_TOP',
  splashTop: 'SPLASH_TOP',
  connectWiseControl: 'CONNECT_WISE_CONTROL',
  stripe: 'STRIPE',
  quickBooksOnline: 'QUICK_BOOKS_ONLINE',
  xero: 'XERO',
  azure: 'AZURE',
  webroot: 'WEBROOT',
  pax8: 'PAX8',
  msteams: 'MS_TEAMS',
  slack: 'SLACK'
};

// End of list of all integrations

// List of all integrations in listing page

const SUBSCRIPTION_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.pax8,
    icon: 'pax8.svg',
    title: <FormattedMessage id="admin.integrations.pax8.title" />,
    description: <FormattedMessage id="admin.integrations.pax8.description" />,
    ldFlag: 'pax8'
  }
];

const DATA_BACKUP_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.acronis,
    icon: 'acronis.svg',
    title: <FormattedMessage id="admin.integrations.acronis.title" />,
    description: (
      <FormattedMessage id="admin.integrations.acronis.description" />
    ),
    ldFlag: 'acronis'
  }
];

const REMOTE_DESKTOP_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.teamViewer,
    icon: 'Teamviewer.svg',
    title: <FormattedMessage id="admin.integrations.teamviewer.title" />,
    description: (
      <FormattedMessage id="admin.integrations.teamviewer.description" />
    )
  },
  {
    integrationId: INTEGRATIONS_MAP.superopsSplashTop,
    icon: 'Splashtop.svg',
    title: <FormattedMessage id="admin.integrations.super.splashtop.title" />,
    description: (
      <FormattedMessage id="admin.integrations.super.splashtop.description" />
    )
  },
  {
    integrationId: INTEGRATIONS_MAP.splashTop,
    icon: 'Splashtop.svg',
    title: <FormattedMessage id="admin.integrations.splashtop.title" />,
    description: (
      <FormattedMessage id="admin.integrations.splashtop.description" />
    )
  },
  {
    integrationId: INTEGRATIONS_MAP.connectWiseControl,
    icon: 'ConnectWiseControl.svg',
    title: <FormattedMessage id="admin.integrations.connectwise.title" />,
    description: (
      <FormattedMessage id="admin.integrations.connectwise.description" />
    )
  }
];

const SPLASHTOP_VERSIONS = [
  INTEGRATIONS_MAP.superopsSplashTop,
  INTEGRATIONS_MAP.splashTop
];

const PAYMENT_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.stripe,
    icon: 'Stripe.svg',
    title: <FormattedMessage id="admin.integrations.stripe.title" />,
    description: (
      <FormattedMessage id="admin.integrations.stripe.description" />
    ),
    ldFlag: 'stripe'
  }
];

const BILLING_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.quickBooksOnline,
    icon: 'Quickbook.svg',
    title: <FormattedMessage id="admin.integrations.quickbooks.title" />,
    description: (
      <FormattedMessage id="admin.integrations.quickbooks.description" />
    )
  },
  {
    integrationId: INTEGRATIONS_MAP.xero,
    icon: 'XeroBlue.svg',
    title: <FormattedMessage id="admin.integrations.xero.title" />,
    description: <FormattedMessage id="admin.integrations.xero.description" />,
    ldFlag: 'xero',
    showTrialWarning: true
  }
];

const ACTIVE_DIRECTORY_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.azure,
    icon: 'Azure.svg',
    title: <FormattedMessage id="admin.integrations.azure.title" />,
    description: <FormattedMessage id="admin.integrations.azure.description" />,
    btnText: 'admin.integrations.card.generateTokens'
  }
];

const ANTIVIRUS_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.webroot,
    icon: 'Webroot.svg',
    title: <FormattedMessage id="admin.integrations.webroot.title" />,
    description: (
      <FormattedMessage id="admin.integrations.webroot.description" />
    )
  }
];

// End of all list of all integrations in listing page

// Integration error types

const ERROR_MAP = {
  500: 'admin.integrations.error.somethingWentWrong',
  2006: 'admin.integrations.error.accessDeniedByUser',
  2007: 'admin.integrations.error.invalidOAuthScope',
  2009: 'admin.integrations.error.oAuthSecurityValidationFailure',
  3322: 'admin.integrations.error.stripeInactive'
};

// End of integration error types

// Types of all integrations used in integration detail page

const ALL_INTEGRATIONS = [
  {
    integrationId: INTEGRATIONS_MAP.stripe,
    icon: 'Stripe.svg',
    title: <FormattedMessage id="admin.integrations.stripe.title" />,
    description: (
      <FormattedMessage id="admin.integrations.stripe.description" />
    ),
    instructions: 'admin.integrations.stripe.instructions',
    infoBanner: <FormattedMessage id="admin.integrations.stripe.banner" />,
    disableDetail: true,
    ldFlag: 'stripe'
  },
  {
    integrationId: INTEGRATIONS_MAP.webroot,
    icon: 'Webroot.svg',
    title: <FormattedMessage id="admin.integrations.webroot.title" />,
    description: (
      <FormattedMessage id="admin.integrations.webroot.description" />
    ),
    instructions: 'admin.integrations.webroot.instructions',
    infoBanner: <FormattedMessage id="admin.integrations.webroot.banner" />
  },
  {
    integrationId: INTEGRATIONS_MAP.bitDefender,
    icon: 'Bitdefender.svg',
    title: <FormattedMessage id="admin.integrations.bitdefender.title" />,
    description: (
      <FormattedMessage id="admin.integrations.bitdefender.commonDescription" />
    )
    // instructions: 'admin.integrations.webroot.instructions',
    // infoBanner: <FormattedMessage id="admin.integrations.webroot.banner" />
  },
  {
    integrationId: INTEGRATIONS_MAP.azure,
    icon: 'Azure.svg',
    title: <FormattedMessage id="admin.integrations.azure.title" />,
    description: <FormattedMessage id="admin.integrations.azure.description" />,
    instructions: 'admin.integrations.azure.instructions'
    // infoBanner: <FormattedMessage id="admin.integrations.azure.banner" />
  },
  {
    integrationId: INTEGRATIONS_MAP.quickBooksOnline,
    icon: 'Quickbook.svg',
    title: <FormattedMessage id="admin.integrations.quickbooks.title" />,
    description: (
      <FormattedMessage id="admin.integrations.quickbooks.description" />
    ),
    instructions: 'admin.integrations.quickbooks.instructions',
    infoBanner: <FormattedMessage id="admin.integrations.quickbooks.banner" />,
    hideDelete: true,
    disableDetail: true
  },
  {
    integrationId: INTEGRATIONS_MAP.xero,
    icon: 'XeroBlue.svg',
    title: <FormattedMessage id="admin.integrations.xero.title" />,
    description: <FormattedMessage id="admin.integrations.xero.description" />,
    ldFlag: 'xero',
    instructions: 'admin.integrations.xero.instructions',
    infoBanner: <FormattedMessage id="admin.integrations.xero.banner" />,
    hideDelete: true,
    disableDetail: true
  },
  {
    integrationId: INTEGRATIONS_MAP.teamViewer,
    icon: 'Teamviewer.svg',
    title: <FormattedMessage id="admin.integrations.teamviewer.title" />,
    description: (
      <FormattedMessage id="admin.integrations.teamviewer.description" />
    ),
    instructions: 'admin.integrations.teamviewer.instructions.detail'
  },
  {
    integrationId: INTEGRATIONS_MAP.splashTop,
    icon: 'Splashtop.svg',
    title: <FormattedMessage id="admin.integrations.splashtop.title" />,
    description: (
      <FormattedMessage id="admin.integrations.splashtop.description" />
    ),
    instructions: 'admin.integrations.splashtop.instructions.detail'
  },
  {
    integrationId: INTEGRATIONS_MAP.superopsSplashTop,
    icon: 'Splashtop.svg',
    title: <FormattedMessage id="admin.integrations.super.splashtop.title" />,
    description: (
      <FormattedMessage id="admin.integrations.super.splashtop.description" />
    ),
    instructions: 'admin.integrations.splashtop.super.instructions.detail'
  },
  {
    integrationId: INTEGRATIONS_MAP.connectWiseControl,
    icon: 'ConnectWiseControl.svg',
    title: <FormattedMessage id="admin.integrations.connectwise.title" />,
    description: (
      <FormattedMessage id="admin.integrations.connectwise.description" />
    ),
    instructions: 'admin.integrations.connectwise.instructions.detail'
  },
  {
    integrationId: INTEGRATIONS_MAP.acronis,
    icon: 'acronis.svg',
    title: <FormattedMessage id="admin.integrations.acronis.title" />,
    description: (
      <FormattedMessage id="admin.integrations.acronis.description" />
    ),
    instructions: 'admin.integrations.acronis.instructions.detail',
    ldFlag: 'acronis'
  },
  {
    integrationId: INTEGRATIONS_MAP.pax8,
    icon: 'pax8.svg',
    title: <FormattedMessage id="admin.integrations.pax8.title" />,
    description: <FormattedMessage id="admin.integrations.pax8.description" />,
    instructions: 'admin.integrations.pax8.instructions.detail',
    ldFlag: 'pax8',
    hideOptionsUntilManualTrigger: true
  }
];

// End of all integrations used in detail page

export {
  ALL_INTEGRATIONS,
  INTEGRATIONS_MAP,
  SUBSCRIPTION_INTEGRATIONS,
  DATA_BACKUP_INTEGRATIONS,
  REMOTE_DESKTOP_INTEGRATIONS,
  SPLASHTOP_VERSIONS,
  PAYMENT_INTEGRATIONS,
  BILLING_INTEGRATIONS,
  ACTIVE_DIRECTORY_INTEGRATIONS,
  ANTIVIRUS_INTEGRATIONS,
  ERROR_MAP
};
